import { useState } from "react";
import MasterLayout from "../Sections/MasterLayout";
import {
  add_fare_rule_endpoint,
  server_post_data,
} from "../../ServiceConnection/serviceconnection";
import Loader from "./Loader";
import SuccesModal from "../Sections/SuccesModal";
import { useNavigate } from "react-router-dom";

export default function AddFareRule() {
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [formData, setFormData] = useState({
    fromStation: "",
    toStation: "",
    distance: "",
    regularFare: "",
    studentFare: "",
    seniorFare: "",
  });

  const [errors, setErrors] = useState({});

  const validateForm = () => {
    const newErrors = {};
    if (!formData.fromStation)
      newErrors.fromStation = "From Station is required";
    if (!formData.toStation) newErrors.toStation = "To Station is required";
    if (!formData.distance) newErrors.distance = "Distance is required";
    if (!formData.regularFare)
      newErrors.regularFare = "Regular Fare is required";
    if (!formData.studentFare)
      newErrors.studentFare = "Student Fare is required";
    if (!formData.seniorFare) newErrors.seniorFare = "Senior Fare is required";
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
    setErrors((prev) => ({ ...prev, [e.target.name]: "" }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validateForm()) return;

    setIsLoading(true);
    const fd = new FormData();
    fd.append("from_station", formData.fromStation);
    fd.append("to_station", formData.toStation);
    fd.append("distance", formData.distance);
    fd.append("regular_fare", formData.regularFare);
    fd.append("student_fare", formData.studentFare);
    fd.append("senior_fare", formData.seniorFare);

    try {
      await server_post_data(add_fare_rule_endpoint, fd);
      setShowSuccessModal(true);
      setFormData({
        fromStation: "",
        toStation: "",
        distance: "",
        regularFare: "",
        studentFare: "",
        seniorFare: "",
      });
      setTimeout(() => setShowSuccessModal(false), 2000);
    } catch (error) {
      console.error(error);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <MasterLayout>
      {isLoading && <Loader />}
      <div className="max-w-5xl  bg-white p-8 rounded-lg shadow-sm border border-gray-200">
        <h2 className="text-2xl font-semibold mb-6">Add Fare Rule</h2>
        <form onSubmit={handleSubmit} className="space-y-6">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            <div>
              <label className="block text-sm font-medium mb-2">
                From Station
              </label>
              <input
                type="text"
                name="fromStation"
                value={formData.fromStation}
                onChange={handleChange}
                className={`w-full border px-3 py-2 rounded-md ${
                  errors.fromStation ? "border-red-500" : "border-gray-300"
                }`}
              />
              {errors.fromStation && (
                <p className="text-sm text-red-500">{errors.fromStation}</p>
              )}
            </div>

            <div>
              <label className="block text-sm font-medium mb-2">
                To Station
              </label>
              <input
                type="text"
                name="toStation"
                value={formData.toStation}
                onChange={handleChange}
                className={`w-full border px-3 py-2 rounded-md ${
                  errors.toStation ? "border-red-500" : "border-gray-300"
                }`}
              />
              {errors.toStation && (
                <p className="text-sm text-red-500">{errors.toStation}</p>
              )}
            </div>

            <div>
              <label className="block text-sm font-medium mb-2">
                Distance (km)
              </label>
              <input
                type="number"
                name="distance"
                value={formData.distance}
                onChange={handleChange}
                className={`w-full border px-3 py-2 rounded-md ${
                  errors.distance ? "border-red-500" : "border-gray-300"
                }`}
              />
              {errors.distance && (
                <p className="text-sm text-red-500">{errors.distance}</p>
              )}
            </div>

            <div>
              <label className="block text-sm font-medium mb-2">
                Regular Fare (₹)
              </label>
              <input
                type="number"
                name="regularFare"
                value={formData.regularFare}
                onChange={handleChange}
                className={`w-full border px-3 py-2 rounded-md ${
                  errors.regularFare ? "border-red-500" : "border-gray-300"
                }`}
              />
              {errors.regularFare && (
                <p className="text-sm text-red-500">{errors.regularFare}</p>
              )}
            </div>

            <div>
              <label className="block text-sm font-medium mb-2">
                Student Fare (₹)
              </label>
              <input
                type="number"
                name="studentFare"
                value={formData.studentFare}
                onChange={handleChange}
                className={`w-full border px-3 py-2 rounded-md ${
                  errors.studentFare ? "border-red-500" : "border-gray-300"
                }`}
              />
              {errors.studentFare && (
                <p className="text-sm text-red-500">{errors.studentFare}</p>
              )}
            </div>

            <div>
              <label className="block text-sm font-medium mb-2">
                Senior Fare (₹)
              </label>
              <input
                type="number"
                name="seniorFare"
                value={formData.seniorFare}
                onChange={handleChange}
                className={`w-full border px-3 py-2 rounded-md ${
                  errors.seniorFare ? "border-red-500" : "border-gray-300"
                }`}
              />
              {errors.seniorFare && (
                <p className="text-sm text-red-500">{errors.seniorFare}</p>
              )}
            </div>
          </div>

          <div className="flex justify-end pt-6 gap-3">
            <button
              type="button"
              className="px-4 py-2 rounded-md btn-secoundary"
              onClick={() => navigate(-1)}
            >
              Cancel
            </button>
            <button
              type="submit"
              className="inline-flex items-center justify-center gap-2 bg-[var(--primary-color)] text-white px-4 py-2 rounded-md hover:bg-[var(--primary-hover)] transition duration-200"
            >
              Save Fare Rule
            </button>
          </div>
        </form>
      </div>
      <SuccesModal
        open={showSuccessModal}
        onClose={() => setShowSuccessModal(false)}
        title="Fare Rule Added Successfully!"
        subtitle="Fare rule has been saved successfully."
        autoClose={false}
      />
    </MasterLayout>
  );
}
